export default __webpack_public_path__ + "static/media/Assignment_Img.f065f4e3.png";